import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { WebhookSubscription, WebhookSubscriptionCreate, WebhookSubscriptionFilter } from '../data/webhookSubscription';

export function createWebhookSubscriptionService(client: AxiosInstance) {
  return createCrudService<WebhookSubscription, WebhookSubscriptionCreate, WebhookSubscriptionFilter>(
    client,
    '/notifications/WebhookSubscription',
    'id',
  );
}

export type WebhookSubscriptionService = CrudService<WebhookSubscription, WebhookSubscriptionCreate, WebhookSubscriptionFilter>;
